import _trim from 'lodash/trim'
import _isEmpty from 'lodash/isEmpty'
import { get } from 'cookies-js'
import { isBrowser } from '../../config/environment'

export const EVERFLOW_TRANSACTIONS_COOKIE = 'ef_tid_c_a_1'

export function getEverFlowTransactionData () {
  if (!isBrowser()) {
    return null
  }
  return get(EVERFLOW_TRANSACTIONS_COOKIE)
}

/**
 * True when Everflow's transaction cookie is present (active attribution).
 * @returns {boolean}
 */
export function hasEverflowTransactionCookie () {
  const tids = getEverFlowTransactionData()
  return typeof tids === 'string' && !_isEmpty(_trim(tids))
}
